export const MCR_COOKIE_KEY_SKIPPED = "MCR_SKIPPED";
export const MCR_COOKIE_KEY_SKIPPED_BY = "MCR_SKIPPED_BY";
